export default "__VITE_ASSET__NTae4HkH__";